import React from "react";
import { useStyles } from "./style";

const DetailBox = ({ title, subtitle }) => {
  const classes = useStyles();
  return (
    <div className={classes.detailContainer}>
      <p className={classes.title}>{title}</p>
      <p className={classes.subtitle}>{subtitle}</p>
    </div>
  );
};

export default DetailBox;
